(function () {
    function init(wrap) {
        if (wrap.dataset.mbInit === "true") return;
        wrap.dataset.mbInit = "true";

        const details = wrap.querySelector("[data-currency-details]");
        const input = wrap.querySelector('input[name="country_code"]');


        wrap.querySelectorAll("[data-mb-country-value]").forEach((btn) => {


            btn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                const value = btn.getAttribute("data-mb-country-value");
                if (!value) return;
                if (details) details.open = false;

                const url = new URL(window.location.href);
                url.searchParams.set("country", value);
                window.location.href = url.href;

            });
        });

        // Close when clicking outside
        if (details) {
            document.addEventListener("click", (e) => {
                if (!details.open) return;

                // If click is outside this wrapper
                if (!wrap.contains(e.target)) {
                    details.open = false;
                }
            });
        }
    }

    function initAll(root) {
        (root || document)
            .querySelectorAll("[data-mb-currency-form]")
            .forEach(init);
    }

    document.addEventListener("DOMContentLoaded", () => initAll(document));
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
